let isModalOpen = false;
const listeners = new Set<() => void>();

export const adminModalStore = {
  setOpen(open: boolean) {
    isModalOpen = open;
    listeners.forEach((listener) => listener());
  },

  subscribe(listener: () => void) {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },

  getSnapshot() {
    return isModalOpen;
  },
};
